import * as Victory from 'victory';

module.exports = Victory;



// WEBPACK FOOTER //
// ./src/@ui/Chart/index.web.js